import { FormControl } from '@angular/forms';
import { BaseNewRequestControlName } from '../../../../../shared/base-new-request-form/base-new-request-form.model';

export enum TASFNewRequestAdditionalControlName {
  BusinessPurpose = 'businessPurpose',
  FellingDate = 'fellingDate',
  InvestmentDescription = 'investmentDescription',
  GrowthPlace = 'growthPlace',
  FellingCause = 'fellingCause',
  TreesList = 'treesList',
  ShrubsList = 'shrubsList',
  Place = 'fellingPlace',
  Street = 'fellingStreet',
  LandRegister = 'landRegister',
  LandNumber = 'fellingLandNumber',
  StreetAbsence = 'streetAbsence',
}

export const TASFNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...TASFNewRequestAdditionalControlName,
};

export enum FellingObjectsControlName {
  InventoryNumber = 'inventoryNumber',
  SpeciesName = 'speciesName',
  TrunkCircumference = 'trunkCircumference',
  ProjectionSurface = 'projectionSurface',
}

export interface TreeFormGroup {
  [FellingObjectsControlName.InventoryNumber]: FormControl<string>;
  [FellingObjectsControlName.SpeciesName]: FormControl<string>;
  [FellingObjectsControlName.TrunkCircumference]: FormControl<number>;
}

export interface ShrubFormGroup {
  [FellingObjectsControlName.InventoryNumber]: FormControl<string>;
  [FellingObjectsControlName.SpeciesName]: FormControl<string>;
  [FellingObjectsControlName.ProjectionSurface]: FormControl<number>;
}

export enum FellingPurpose {
  NotBusiness = 0,
  Business = 1,
}
